<script lang="ts">
	import type { PageData, PageLoad } from './$types';
	import { PUBLIC_FRONTEND_URL, PUBLIC_DIRECTUS_BACKEND } from '$env/static/public';
	import { page } from '$app/stores';
	import SectionSwitcher from '$lib/components/layout/SectionSwitcher.svelte';
	import CanonicalLinks from '$lib/components/util/CanonicalLinks.svelte';

	import adminApi from '$lib/api/ecom/shopifyAdmin';
	import shopifyAdmin from '$lib/api/ecom/shopifyAdmin';
	import { onMount } from 'svelte';

	export let data: PageData;
	$: pageData = data.page;
</script>

<svelte:head>
	<title>{pageData.seo_title}</title>
	<meta name="description" content={pageData.seo_description} />

	<meta property="og:title" content={pageData.seo_title} />
	<meta property="og:type" content="website" />
	<meta property="og:url" content={PUBLIC_FRONTEND_URL + $page.url.pathname} />
	<meta property="og:description" content={pageData.seo_description} />
	<meta
		property="og:image"
		content={PUBLIC_DIRECTUS_BACKEND + 'assets/' + pageData.seo_image?.id + '.jpg'}
	/>
</svelte:head>

<SectionSwitcher sections={pageData.sections} />
